export const CALLBACKREQUESTTABS=[
    {
        id:1,
        name:"Pending Call Request"
    },
    {
        id:2,
        name:"Call History"
    }
]